import { useState } from "react";

import { PageContainer } from "~/components/layout/PageContainer";
import { PageHeader } from "~/components/layout/PageHeader";
import SellerDetails from "~/pages/commercial-team/components/SellerDetails";
import SellersList from "~/pages/commercial-team/components/SellersList";
import { Seller } from "~/services/sellerService";

const CommercialTeamPage = () => {
  const [selectedSeller, setSelectedSeller] = useState<Seller | null>(null);

  return (
    <PageContainer>
      <PageHeader title="Equipo Comercial" />

      <SellersList
        onSellerSelect={setSelectedSeller}
        selectedSeller={selectedSeller}
      />

      {selectedSeller ? (
        <SellerDetails key={selectedSeller.id} seller={selectedSeller} />
      ) : (
        <div className="flex min-h-[240px] items-center justify-center rounded-lg border border-dashed bg-muted/40 p-8 text-center">
          <p className="text-sm text-muted-foreground">
            Selecciona un vendedor para ver sus detalles
          </p>
        </div>
      )}
    </PageContainer>
  );
};

export default CommercialTeamPage;
